export default __webpack_public_path__ + "static/xcad-coin-b6fe0b24500bdf3b1b4af454b374430d.svg";